import React from 'react'
import { useController } from 'react-hook-form'
import { Checkbox } from '@maui/elements'
import { useDraft } from '@maui/hooks'
import { WEEKDAYS } from '@/utilities'

export const ControlledCheckbox = ({ name, control, label, register, required = false, ...props }) => {
  const { field } = useController({
    control,
    name,
    rules: { required }
  })

  const [value, setValue] = useDraft(field.value || WEEKDAYS.map(day => day.value))

  return (
    <Checkbox
      {...props}
      {...register(name, { ...props.required })}
      onChange={(e) => {
        const valueCopy = [...value]
        if (e.target.checked) {
          valueCopy.push(e.target.value)
        } else {
          const index = valueCopy.indexOf(e.target.value)
          if (index > -1) {
            valueCopy.splice(index, 1)
          }
        }
        field.onChange(valueCopy)
        setValue(valueCopy)
      }}
      value={props.value}
      checked={value.includes(props.value)}
    >
      {label}
    </Checkbox>
  )
}
